module.exports = __webpack_public_path__ + "static/media/treasure-chest.4ea4c71c.svg";